import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class WorkScheduleTemplateForm extends ObjetKForm {
  code: string = ''
  label: string = ''
  order: number = 0
  description: string = ''
  weeklyHours: number = 0
  isDefault: boolean = false

  static validationRules = {
    code: combineRules(requiredRule('Le code est obligatoire')),
    label: combineRules(requiredRule('Le libellé est obligatoire'))
  }

  constructor(data?: Partial<WorkScheduleTemplateForm>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.order = data.order ?? 0
      this.description = data.description ?? ''
      this.weeklyHours = data.weeklyHours ?? 0
      this.isDefault = data.isDefault ?? false
    }
  }
}
